import i18n from "@/locales";

export default [
  {
    // 结构开户结果
    path: "/open-institution/result",
    name: "OpenInstitutionResult",
    component: () => import("@/views/open-institution/result/index.vue"),
    meta: {
      showHeader: false,
      keepAlive: false,
      title: '开户进度'
    }
  }
];
